import { defineComponent as _defineComponent } from 'vue'
import LinkViewObject = Vertica.LouisPoulsen.Application.Content.Blocks.ViewObjects.LinkViewObject;
import { computed, toRef } from 'vue';
import { useSwiper, ManagedSwiper, SwiperNavigationButton } from '@/ui/shared/swiper';
import { useEsc } from '@/ui/composables';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { useStandardLoadManager, SlideRenderState } from '@/ui/shared/swiper/lazyload';


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenImageCarousel',
  props: {
    images: { default: () => [] },
    initialIndex: { default: 0 },
    bgColor: { default: '#F9F9F9' }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { images: CarouselImage[], initialIndex: number, bgColor: string }





useEsc(() => {
    emit('close');
});

const { swiperManager } = useSwiper<CarouselImage>({
    slides: toRef(props, 'images'),
    swiperOptions: {
        loop: true,
        slidesPerView: 1,
        initialSlide: props.initialIndex
    }
});

const { getSlideRenderStatus } = useStandardLoadManager(swiperManager);
const slideStatuses = computed(() => {
    return swiperManager.slides.value.map((_, index) => getSlideRenderStatus(index));
});

function getSrc(image: CarouselImage) {
    if (image.imageUrl) { return image.imageUrl + '?format=jpg&quality=90'; }
    if (image.buffer) { return image.buffer.toString(); }
}

const activeIndex = computed<number | undefined>(() => {
    return swiperManager.activeIndex.value;
});

const activeSlide = computed<CarouselImage | undefined>(() => {
    return swiperManager.activeSlide.value;
});

const sliderCountText = computed<string>(() => {
    if (activeIndex.value === undefined) {
        return '';
    } else {
        const position = swiperManager.activeIndex.value + 1;
        const size = props.images.length;
        return `${position} / ${size}`;
    }
});

const sliderLinkText = computed<string>(() => {
    if (activeSlide.value === undefined) {
        return '';
    } else {
        return swiperManager.activeSlide.value.title;
    }
});

const sliderLink = computed<LinkViewObject | null>(() => {
    if (activeSlide.value === undefined) {
        return null;
    }
    if (!activeSlide.value.link) {
        return null;
    }
    return activeSlide.value.link;
});

const sliderLinkUrl = computed<string | null>(() => {
    if (sliderLink.value === null) {
        return null;
    }
    return sliderLink.value.url;
});

const sliderLinkTarget = computed<string>(() => {
    if (sliderLink.value === null) {
        return '';
    }
    return sliderLink.value.openInNewWindow ? '_blank' : '';
});

function getSliderImageSrcset(image:CarouselImage):string {
    if (image.buffer) return '';
    const url = image.imageUrl;
    const sizes: number[] = [320, 640, 1024, 1600];
    const srcset = sizes
        .map(width => {
            return `${encodeURI(url)}?width=${width}&scale=both&format=jpg&quality=90&bgcolor=${props.bgColor.replace('#', '')} ${width}w`;
        })
        .join(', ');
    return srcset;
}

const breakpointIsActive = useBreakpoints();
const layout = computed<'full'|'mobile'>(() => {
    return breakpointIsActive.value.large ? 'full' : 'mobile';
});


return { __sfc: true,props, emit, swiperManager, getSlideRenderStatus, slideStatuses, getSrc, activeIndex, activeSlide, sliderCountText, sliderLinkText, sliderLink, sliderLinkUrl, sliderLinkTarget, getSliderImageSrcset, breakpointIsActive, layout, ManagedSwiper, SwiperNavigationButton, SlideRenderState }
}

})